export enum OrganizationStatus {
    ACTIVE = "active",
    SUSPEND = "suspend",
}